import { render, staticRenderFns } from "./ProductosView.vue?vue&type=template&id=28d83213"
import script from "./ProductosView.vue?vue&type=script&lang=js"
export * from "./ProductosView.vue?vue&type=script&lang=js"
import style0 from "./ProductosView.vue?vue&type=style&index=0&id=28d83213&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports